var map = {
	"./Approved.svg": 3761,
	"./AwaitingParts.svg": 3762,
	"./Closed.svg": 3763,
	"./Completed.svg": 3764,
	"./Excel.svg": 3765,
	"./Exportall_grey.svg": 3766,
	"./Exportall_grey_circle.svg": 3767,
	"./InProgress.svg": 3768,
	"./New.svg": 3769,
	"./View_Pic_Grey.svg": 3770,
	"./accident.svg": 3771,
	"./account.svg": 3772,
	"./addOrange.svg": 3773,
	"./addUser.svg": 3774,
	"./addVehicle.svg": 3775,
	"./address.svg": 3776,
	"./alert.svg": 3777,
	"./all_active.svg": 3778,
	"./all_active_es.svg": 3779,
	"./arrow-down.svg": 3780,
	"./arrow-up.svg": 3781,
	"./arrowRight.svg": 3782,
	"./awaiting_parts_grey.svg": 3783,
	"./awaiting_parts_orange.svg": 3784,
	"./back-btn.svg": 3785,
	"./back-button-grey.svg": 3786,
	"./backButton.svg": 3787,
	"./bills_of_landing_active.svg": 3788,
	"./bills_of_landing_active_es.svg": 3789,
	"./bobTail.svg": 3790,
	"./book-solid.svg": 3791,
	"./boxTruck.svg": 3792,
	"./calanderIcon.svg": 3793,
	"./cameraSelected.svg": 3794,
	"./camera_selected.svg": 3795,
	"./chat-icon.svg": 3796,
	"./circle-Exportall_grey.svg": 3797,
	"./circle-export.svg": 3798,
	"./circle-exportUser.svg": 3799,
	"./circle-import.svg": 3800,
	"./circle-importUser.svg": 3801,
	"./circle-viewall.svg": 3802,
	"./clearAll.svg": 3803,
	"./close-popup.svg": 3804,
	"./closeMap.svg": 3805,
	"./closed-Orange.svg": 3806,
	"./closed-grey.svg": 3807,
	"./clusterIcon.svg": 3808,
	"./communication_records_active.svg": 3809,
	"./communication_records_active_es.svg": 3810,
	"./company.svg": 3811,
	"./companyIcon.svg": 3812,
	"./complete-Orange.svg": 3813,
	"./complete-grey.svg": 3814,
	"./csa.svg": 3815,
	"./csaSnapshot.svg": 3816,
	"./dailyDocuments.svg": 3817,
	"./dashboard.svg": 3818,
	"./dashboardIcon.svg": 3819,
	"./date.svg": 3820,
	"./delete.svg": 3821,
	"./deleteCircle.svg": 3822,
	"./delivery_receipts_active.svg": 3823,
	"./delivery_receipts_active_es.svg": 3824,
	"./departments.svg": 3825,
	"./departmetEdit.svg": 3826,
	"./developer.svg": 3827,
	"./direction.svg": 3828,
	"./dispatch_records_active.svg": 3829,
	"./dispatch_records_active_es.svg": 3830,
	"./document.svg": 3831,
	"./documents.svg": 3832,
	"./dot.svg": 3833,
	"./dotAudit.svg": 3834,
	"./dotauditIcon.svg": 3835,
	"./downarrowIcon.svg": 3836,
	"./download.svg": 3837,
	"./downloadCenter.svg": 3838,
	"./downloadCenterMenu.svg": 3839,
	"./driver-behaviour.svg": 3840,
	"./driver.svg": 3841,
	"./dryVan.svg": 3842,
	"./dtc.svg": 3843,
	"./dualCam.svg": 3844,
	"./dump.svg": 3845,
	"./edit.svg": 3846,
	"./editLogIcon.svg": 3847,
	"./editSvg.svg": 3848,
	"./en.svg": 3849,
	"./es.svg": 3850,
	"./excelNew.svg": 3851,
	"./export-grey.svg": 3852,
	"./export.svg": 3853,
	"./exportUser.svg": 3854,
	"./feedback.svg": 3855,
	"./file-pdf-regular.svg": 3856,
	"./filter.svg": 3857,
	"./flatBed.svg": 3858,
	"./fleet.svg": 3859,
	"./fleetCompanies.svg": 3860,
	"./fleetdriverIcon.svg": 3861,
	"./fleetvehiclesIcon.svg": 3862,
	"./fletBed.svg": 3863,
	"./fuel.svg": 3864,
	"./full.svg": 3865,
	"./hamburger.svg": 3866,
	"./help-icon.svg": 3867,
	"./historyLogs.svg": 3868,
	"./icon-delete.svg": 3869,
	"./icon-export.svg": 3870,
	"./icon-menu-logs.svg": 3871,
	"./ifta.svg": 3872,
	"./import.svg": 3873,
	"./importUser.svg": 3874,
	"./in_progress_grey.svg": 3875,
	"./in_progress_orange.svg": 3876,
	"./infoTruck.svg": 3877,
	"./inspection-dvir.svg": 3878,
	"./inspection.svg": 3879,
	"./key.svg": 3880,
	"./leftArrow.svg": 3881,
	"./location.svg": 3882,
	"./locationMap.svg": 3883,
	"./log.svg": 3884,
	"./logEdit.svg": 3885,
	"./logHistory.svg": 3886,
	"./logoutIcon.svg": 3887,
	"./logs.svg": 3888,
	"./logsIcon.svg": 3889,
	"./mack.svg": 3890,
	"./mail.svg": 3891,
	"./main_camera.svg": 3892,
	"./mappinPopup.svg": 3893,
	"./menu_companies.svg": 3894,
	"./menu_dailyLog.svg": 3895,
	"./menu_reports.svg": 3896,
	"./menu_reseller.svg": 3897,
	"./menu_vehicle.svg": 3898,
	"./messageSender.svg": 3899,
	"./messaging.svg": 3900,
	"./new_login.svg": 3901,
	"./ninePin.svg": 3902,
	"./nonEdit.svg": 3903,
	"./notFull.svg": 3904,
	"./not_started_grey.svg": 3905,
	"./not_started_orange.svg": 3906,
	"./otherTrailer.svg": 3907,
	"./otherTruck.svg": 3908,
	"./other_documents_active.svg": 3909,
	"./other_documents_active_es.svg": 3910,
	"./overview.svg": 3911,
	"./page-first.svg": 3912,
	"./page-last.svg": 3913,
	"./page-next.svg": 3914,
	"./page-prev.svg": 3915,
	"./phone.svg": 3916,
	"./pickup.svg": 3917,
	"./pneumaticTrailer.svg": 3918,
	"./policy.svg": 3919,
	"./popupClose.svg": 3920,
	"./popupConfirm.svg": 3921,
	"./popupDelete.svg": 3922,
	"./privatePassenger.svg": 3923,
	"./qbdii.svg": 3924,
	"./receipts_active.svg": 3925,
	"./receipts_active_es.svg": 3926,
	"./reeferTrailer.svg": 3927,
	"./refreshCircle.svg": 3928,
	"./renewal.svg": 3929,
	"./repair.svg": 3930,
	"./reportIcon.svg": 3931,
	"./reports.svg": 3932,
	"./save-regular.svg": 3933,
	"./scoreCard.svg": 3934,
	"./searchGrey.svg": 3935,
	"./selectedConnection.svg": 3936,
	"./share.svg": 3937,
	"./sixPin.svg": 3938,
	"./sort.svg": 3939,
	"./speedometer.svg": 3940,
	"./spotlightGreen.svg": 3941,
	"./spotlightGrey.svg": 3942,
	"./spotlightRed.svg": 3943,
	"./straightTruck.svg": 3944,
	"./supportIcon.svg": 3945,
	"./switch.svg": 3946,
	"./tankerTrailer.svg": 3947,
	"./tick.svg": 3948,
	"./time.svg": 3949,
	"./timePicker.svg": 3950,
	"./toggle-off.svg": 3951,
	"./toggle-on.svg": 3952,
	"./tools.svg": 3953,
	"./tractorDayCab.svg": 3954,
	"./tractorSleeper.svg": 3955,
	"./undelete.svg": 3956,
	"./unsaved.svg": 3957,
	"./update.svg": 3958,
	"./upload.svg": 3959,
	"./usdot.svg": 3960,
	"./user.svg": 3961,
	"./userprofileIcon.svg": 3962,
	"./users.svg": 3963,
	"./vacuumTrailer.svg": 3964,
	"./vacuumTruck.svg": 3965,
	"./van.svg": 3966,
	"./vehicle-behaviour.svg": 3967,
	"./vehicle.svg": 3968,
	"./vehicleIcon.svg": 3969,
	"./viewArrow.svg": 3970,
	"./viewDocument.svg": 3971,
	"./viewReports.svg": 3972,
	"./viewStatus.svg": 3973,
	"./viewallMap.svg": 3974,
	"./violation.svg": 3975,
	"./volvo.svg": 3976,
	"./weigh_tickets_active.svg": 3977,
	"./weigh_tickets_active_es.svg": 3978,
	"./whitecheck_new.svg": 3979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3760;